export const HelpText = ({ children, className, }: React.PropsWithChildren<{
  className?: string;
}>) => {
  return (
    <div className='help-text'>
      <span className={`text-sm text-gray-700 ${className}`}>{children}</span>
    </div>
  );
};
